import { Component, OnInit } from '@angular/core';
import { MatDialogTitle, MatDialogClose, MatDialogContent } from '@angular/material/dialog';
import { CdkScrollable } from '@angular/cdk/scrolling';

@Component({
    selector: 'app-connection-lost-modal',
    templateUrl: './connection-lost-modal.component.html',
    styleUrls: ['./connection-lost-modal.component.scss'],
    imports: [MatDialogTitle, MatDialogClose, CdkScrollable, MatDialogContent]
})
export class ConnectionLostModalComponent implements OnInit {

  constructor() { }

  ngOnInit() {}

}
